<template>
  <div class="footer-help">
    <div class="footer-help__content">
      <div class="footer-help__heading">
        {{ $t('Help needed?') }}
      </div>

      <p class="footer-help__description">
        {{ $t('We have collected all questions about our digital gift cards.') }}
      </p>
    </div>

    <div class="footer-help__faq">
      <UiCollapsable :label="$t('Where can I use the gift card?')">
        {{ $t('The gift card is valid in all our stores and our online shop.') }}
      </UiCollapsable>

      <UiCollapsable :label="$t('How long is the gift card valid?')">
        {{ $t('The gift card is valid for 3 years, and the validity is also stated on the card.') }}
      </UiCollapsable>

      <UiCollapsable :label="$t('Can I return the gift card?')">
        {{ $t('It is not possible to return the gift card after purchase.') }}
      </UiCollapsable>

      <UiCollapsable :label="$t('Can I order a large number of gift cards for my company?')">
        {{ $t('For business inquiries, please contact our corporate department at zakelijk@dille-kamille.com.') }}
      </UiCollapsable>
    </div>
  </div>
</template>

<style src="~layers/app/components/Footer/Help.css" />
